@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-2 py-4" [class.embedded]="isEmbedded" [class.edocs]="isEdocs">
        <div class="container-flex d-flex flex-column align-items-center">
            <div class="announcements-container" [class.mb-4]="$visibleAnnouncements() > 0">
                @for (announcement of $announcements(); track announcement) {
                    <announcer class="mb-1"
                               [_title]="announcement.title"
                               [_message]="announcement.message"
                               [_level]="announcement.level"
                               (_isVisibleEvent)="$visibleAnnouncements.set($visibleAnnouncements() - 1)"
                    ></announcer>
                }
            </div>

            <div class="card definition-area">
                @if (!$model().isActive) {
                    <!-- Fluxo desativado -->
                    <div class="message h4">
                        <b>Este Fluxo encontra-se desativado!</b>
                    </div>
                } @else if ($model().version == 1 && !$model().isPublished) {
                    <!-- Fluxo não publicado -->
                    <div class="message h4">
                        <b>Este Fluxo não está publicado!</b>
                    </div>
                } @else if ($model().targetId == FlowTarget.Unit && !$papeisUnitIdsArray().includes($model().publishedUnitId)) {
                    <!-- Restrição de público-alvo: Unidade -->
                    <div class="message h4">
                        <b>O público-alvo deste Fluxo está restrito aos servidores com algum papel lotado no seguinte Setor:</b>
                        <span class="h6 info-font text-highlight mt-5">{{$unit().nome}} - {{$unit().nomeCurto}} - {{$organization().sigla}} - {{$patriarch().sigla}}</span>
                    </div>
                } @else if ($model().targetId == FlowTarget.Organization && !$papeisOrganizationIdsArray().includes($model().publishedOrganizationId)) {
                    <!-- Restrição de público-alvo: Organização -->
                    <div class="message h4">
                        <b>O público-alvo deste Fluxo está restrito aos servidores com algum papel lotado no seguinte Órgão:</b>
                        <span class="h6 info-font text-highlight mt-5">{{$organization().razaoSocial}} - {{$organization().sigla}} - {{$patriarch().sigla}}</span>
                    </div>
                } @else if ($model().targetId == FlowTarget.Patriarch && !$papeisPatriarchIdsArray().includes($model().publishedPatriarchId)) {
                    <!-- Restrição de público-alvo: Patriarca -->
                    <div class="message h4">
                        <b>O público-alvo deste Fluxo está restrito aos servidores com algum papel lotado no seguinte Patriarca:</b>
                        <span class="h6 info-font text-highlight mt-5">{{$patriarch().razaoSocial}} - {{$patriarch().sigla}}</span>
                    </div>
                } @else if ($model().targetId == FlowTarget.Whitelist && !$hasWhitelistAccess()) {
                    <!-- Restrição de público-alvo: Whitelist -->
                    <div class="message h4">
                        <b class="mb-5 text-center">O público-alvo deste Fluxo está restrito aos servidores com algum papel lotado em algum dos seguintes setores ou em algum setor dos seguintes órgãos:</b>
                        @for (item of $configSchema().whitelist; track item.id) {
                            <span class="h6 info-font text-highlight mb-3">
                                {{ item.name }}
                            </span>
                        } @empty {
                            <span class="h6 info-font text-highlight">
                                (Carregando...)
                            </span>
                        }
                    </div>
                } @else {
                    @if (isEmbedded) {
                        <!-- Name tag -->
                        <div class="name-tag-wrapper">
                            <div class="name-tag-container">
                                <span class="name-tag-label">
                                    <i class="fas fa-user mr-1"></i>
                                    Você está logado como
                                </span>
                                <span class="name-tag">
                                    {{$currentUser().nome}}
                                </span>
                            </div>
                        </div>
                    }

                    <!-- Header -->
                    <div class="header">
                        <!-- Title -->
                        <div class="title">
                            <!-- Breadcrumb -->
                            @if (!isFromConecta && !isEmbedded && !isEdocs) {
                                <a [routerLink]="[Enums.PagesPaths.FlowDefinitionList]"><span>Iniciar um Fluxo</span></a>

                                @if ($isContextInUse() && $model().contextId != null && (!isDirectAccess || isFromGrouping)) {
                                    <i class="fas fa-chevron-right mx-1"></i>
                                    <a (click)="loadContextSelection()" (keyDown)="loadContextSelection()">
                                        <span>{{$flowDefinitionContext()?.name || 'Grupo de Fluxos'}}</span>
                                    </a>
                                }

                                <i class="fas fa-chevron-right mx-1"
                                   [class.invisible]="$shouldShowContextSelector()"
                                ></i>
                            }

                            <!-- Nome -->
                            <div class="flow-definition-name">
                                <span class="m-0"
                                      [class.h5]="!isEmbedded"
                                      [class.text-highlight]="!isEmbedded"
                                      [class.invisible]="$shouldShowContextSelector()"
                                >{{$canShowHeaderInfo() ? $model().publishedName : '???'}}</span>
                            </div>
                        </div>

                        <!-- Tags -->
                        <div class="tags">
                            @if ($patriarchAcronym() != null && $organizationAcronym() != null && $unitAcronym() != null) {
                                <!-- Caixa de Fluxos -->
                                <span class="flow-inbox info-font text-highlight"
                                      matTooltip="Setor responsável pelo Fluxo: {{$patriarchAcronym()}} - {{$organizationAcronym()}} - {{$unitAcronym()}}"
                                >{{$patriarchAcronym()}} - {{$organizationAcronym()}} - {{$unitAcronym()}}</span>
                            }

                            <!-- Versão -->
                            <span class="version-tag px-1 py-0"
                                  matTooltip="Versão a ser instanciada"
                                  [class.invisible]="$shouldShowContextSelector()"
                            >Versão {{$instanceVersion()}}</span>
                        </div>
                    </div>

                    @if (!isEmbedded) {
                        <hr />
                    }

                    @if ($shouldShowContextSelector()) {
                        <!-- Seletor de Fluxos de um Grupo -->
                        <div class="card task-area m-1">
                            <ngx-spinner bdColor="#fbfbfb" size="medium" color="#388fad" type="line-scale-pulse-out-rapid" [fullScreen]="false"></ngx-spinner>

                            @if ($isBootstrapFinished()) {
                                <!-- Header -->
                                @if ($publishedFlowDefinitions().length > 0) {
                                    <div class="task-header px-1">
                                        <h6>Escolha, a seguir, qual dos Fluxos publicados deste Grupo você deseja iniciar:</h6>
                                    </div>
                                    <hr>
                                }

                                <div class="task-container context">
                                    @if ($publishedFlowDefinitions().length == 0) {
                                        <!-- Sem Fluxos publicados no Grupo -->
                                        <div class="message h5">
                                            <b>Não há Fluxos publicados neste Grupo!</b>
                                        </div>
                                    } @else {
                                        <!-- Lista de Fluxos publicados no Grupo -->
                                        @for (flowDefinition of $publishedFlowDefinitions(); track flowDefinition) {
                                            <div class="link-container font-weight-bold p-1">
                                                <i class="fas fa-external-link-alt"></i>

                                                <!-- Nome -->
                                                <span class="flow-definition-name text-highlight"
                                                      matTooltip='Clique para iniciar o Fluxo "{{flowDefinition.name}}"'
                                                      (click)="loadFlowDefinition(flowDefinition.id)"
                                                      (keyDown)="loadFlowDefinition(flowDefinition.id)"
                                                >{{flowDefinition.name}}</span>

                                                <!-- Versão -->
                                                <span class="version-tag px-1 py-0" matTooltip="Versão a ser instanciada">
                                                    Versão {{flowDefinition.isPublished ? flowDefinition.version : flowDefinition.version - 1}}
                                                </span>
                                            </div>
                                        }
                                    }
                                </div>
                            }
                        </div>
                    } @else {
                        @if (Utils.isNotNullOrEmpty($model().publishedDescription?.trim())) {
                            <!-- Descrição e Informações -->
                            <div class="card description-area mx-1 mt-2" #descriptionAreaRef
                                 [class.show]="$isShowingDescription() || isEmbedded"
                                 [ngClass]="!isEmbedded ? 'mb-4' : 'mb-5'"
                            >
                                <div class="description-tag info-font"
                                     (click)="!isEmbedded ? toggleDescription() : return"
                                     (keyDown)="!isEmbedded ? toggleDescription() : return"
                                >
                                    @if (!isEmbedded) {
                                        <i class="toggle-description fas fa-chevron-circle-right mr-1" [class.on]="$isShowingDescription()"></i>
                                    }

                                    <span>Descrição e Informações</span>

                                    @if (!isEmbedded) {
                                        <i class="toggle-description fas fa-chevron-circle-left ml-1" [class.on]="$isShowingDescription()"></i>
                                    }
                                </div>

                                <div class="description-message-container" [class.show]="$isShowingDescription()">
                                    <div class="description-message" #descriptionMessageRef
                                         [hidden]="!$isShowingDescription()"
                                         [safeHtmlContent]="$descriptionHtml()"
                                    ></div>
                                </div>
                            </div>
                        }

                        @if ($flowObjectToExecute() != null) {
                            <!-- Canvas -->
                            <div class="card task-area m-1">
                                <!-- Header -->
                                <div class="task-header p-1" #taskHeaderRef>
                                    @if (!isEmbedded) {
                                        <!-- Ícone da Tarefa -->
                                        <div class="task-icon-container mr-2"
                                             matTooltip="Tarefa de {{FlowObjectTypeCategory.get(+$flowObjectToExecute().typeId)}}"
                                        >
                                            @switch ($flowObjectToExecute().typeId) {
                                                @case (FlowObjectType.StartForm) {
                                                    <i class="icon fas fa-file-alt"></i>
                                                }
                                                @case (FlowObjectType.TaskForward) {
                                                    <i class="icon fas fa-paper-plane"></i>
                                                }
                                                @case (FlowObjectType.TaskAcknowledge) {
                                                    <i class="icon fas fa-check"></i>
                                                }
                                                @case (FlowObjectType.GatewayApprove) {
                                                    <i class="icon fas fa-thumbs-up"></i>
                                                }
                                                @case (FlowObjectType.Finish) {
                                                    <i class="icon fas fa-stop-circle"></i>
                                                }
                                            }
                                        </div>
                                    }

                                    <!-- Nome da Tarefa -->
                                    <h6>
                                        <span>{{$flowObjectToExecute().publicName || $flowObjectToExecute().name}}</span>
                                    </h6>
                                </div>

                                @if (!isEmbedded) {
                                    <hr />
                                }

                                <!-- Body -->
                                <div class="task-container" #taskContainerRef>
                                    @if (!isEmbedded) {
                                        <!-- Loading (antes do "submit") -->
                                        <ngx-spinner bdColor="#fbfbfb" size="medium" color="#388fad" type="line-scale-pulse-out-rapid" [fullScreen]="false">
                                            <h6>Processando...</h6>
                                        </ngx-spinner>

                                        <!-- Loading (após o "submit") -->
                                        <ngx-spinner name="afterSubmit" bdColor="#fbfbfb" size="medium" color="#388fad" type="line-scale-pulse-out-rapid" [fullScreen]="false">
                                            <h6>Processando...</h6>
                                        </ngx-spinner>
                                    } @else {
                                        <ngx-spinner name="afterSubmit" bdColor="#fdfdfd" size="medium" color="#388fad" type="line-scale-pulse-out-rapid" [fullScreen]="false">
                                            <h6>Processando...</h6>
                                        </ngx-spinner>
                                    }

                                    @if ($isBootstrapFinished()) {
                                        <!-- Switch do tipo de Tarefa a ser desenhada -->
                                        <div class="wrapper" #wrapperRef>
                                            @if ($flowObjectToExecute().isFlowStarter && $flowObjectToExecute().typeId == FlowObjectType.StartForm) {
                                                <fob-form [_flowObjectDefinition]="$flowObjectToExecute()"
                                                          [_flowDefinition]="$model()"
                                                          (_submitEvent)="createFlowInstance($event)"
                                                ></fob-form>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                        @if (isFromConecta && $isBootstrapFinished()) {
                            <!-- Botão para retorno ao Conecta ES -->
                            <a class="return-to" href="//conecta.{{conectaEnvironmentSegment}}es.gov.br/servico/{{$model().catalogServiceId}}">
                                <div class="btn btn-outline-primary mt-4">
                                    <i class="fas fa-arrow-left mr-2"></i>
                                    <span>Voltar para o serviço</span>
                                </div>
                            </a>
                        }
                    }
                }

                @if (isEdocs) {
                    <!-- Botão para retorno ao E-Docs -->
                    <div class="return-to">
                        <div class="btn btn-outline-primary mt-4" (click)="backToEdocs()" (keyDown)="backToEdocs()">
                            <i class="fas fa-arrow-left mr-2"></i>
                            <span>Voltar</span>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
}
